import i18n from '@/libs/i18n'

export default {
  isDineIn: (state: any) => state.business.isDineIn && state.business.dine_in_label === 'dinein',
  isCarPickUp: (state: any) => state.business.isCarPickup,
  isDelivery: (state: any) => state.business.isDelivery,
  hidePrice: (state: any) => state.business?.hide_price ?? false,
  isService: (state: any) => state.business.isDineIn && state.business.dine_in_label === 'product_service',
  multiplePriceOption: (state: any) => state.business?.multiple_price_option ?? 0,
  calories: (state: any) => state.business.calories,
  ingredients: (state: any) => state.business.ingredients,
  modifiers: (state: any) => state.business.modifiers,
  preparationTime: (state: any) => state.business.preparation_time,
  preparation_time_with_delivery_time: (state: any) => state.business.preparation_time_with_delivery_time,
  branch_switch_in_dine_in: (state: any) => state.business.branch_switch_in_dine_in,
  hide_note_on_item: (state: any) => state.business.hide_note_on_item,
  item_note_character_limit: (state: any) => {
    const limit = Number(state.business.item_note_character_limit)
    return limit > 0 ? limit : 25
  },
  stickers: (state: any) => state.business.stickers,
  enable_promotions: (state: any) => state.business.enable_promotions,
  suggestedItems: (state: any) => state.business.suggested_items,
  showDeliveryBtn: (state: any) => state.business?.showDeliveryBtn ?? false,
  randomize: (state: any) => state.business?.randomize ?? false,
  showCarPickupBtn: (state: any) => state.business?.showCarPickupBtn ?? false,
  dineinSettings: (state: any) => state.business.checkoutDineIn,
  productServiceSettings: (state: any) => state.business.checkoutDineIn,
  pickupSettings: (state: any) => state.business.checkoutCarPickup,
  deliverySettings: (state: any) => state.business.checkoutDelivery,
  deliveryMinOrder: (state: any) => state.business.checkoutDelivery?.min_order ?? 0,
  labels: (state: any) => {
    const { locale } = i18n
    const capitalize = (text?: string, fallback = ''): string => (text ?? fallback).replace(/^./, c => c.toUpperCase())
    return {
      table_label: locale === 'ar' ? 'الطاولة' : capitalize(state.business?.table_label, 'Table'),
      info_label: locale === 'ar' ? 'معلومات' : 'Info',
      floor_label: state.business?.floor_label ?? 'floor',
      kitchen_label: state.business?.kitchen_label ?? 'kitchen',
    }
  },
  dinInLabel: (state: any) => state.business.dine_in_label ?? 'dinein',
  dinInButtonLabel: (state: any) => state.business.dinein_btn_label ?? state.business.dine_in_label ?? 'dinein',
}
